<template>
  <div class="main-area">
    <div class="container-fluid"></div>
    <div class="container-fluid centered text-justify">
      <h1 class="centered">Контакты</h1>
      <br>
      <contacts :height="500"></contacts>
    </div>
  </div>
</template>

<script>
import Contacts from '@/components/Contacts'

export default {
  components: {
    Contacts
  }
}
</script>



// WEBPACK FOOTER //
// Contacts.vue?4335617d